'use strict';

module.exports = [function () {

        /**
         *  Usage Examples:     <p>First word only: {{msg | capitalize}}</p>
         *                      <p>All words: {{msg | capitalize:true}}</p> 
         */
        return function (input, all) {
            var reg = (all) ? /([^\W_]+[^\s-]*) */g : /([^\W_]+[^\s-]*)/;
            return (!!input) ? input.replace(reg, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            }) : '';
        };
    }];




//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/filters/CapitalizeFilter.js
// module id = 405
// module chunks = 0